export default "__VITE_PUBLIC_ASSET__7136d9dd__"